import React, { useEffect, useState } from "react";
import UseGeneral from "../../hooks/useGeneral";
import "./style.css";
import CopyRight from "../../components/footer/copyRight";
import { footerData } from "../../data/footer";
import { Link } from "react-router-dom";
import IconWithText from "../../components/iconWithText";
import PopUp from "../../components/popup";
import { Phone, whatsApp } from "../../assets/svgIcons";
import Branches from "./components/Branches";
import ReturnPolicy from "./components/ReturnPolicy";
import DeliveryPolicy from "./components/deliveryPolicy";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";

const Footer = () => {
  const { language, data } = UseGeneral();
  const [contactOpen, setContactOpen] = useState(false);
  const [branchesOpen, setBranchesOpen] = useState(false);
  const [deliveryPolicyOpen, setDeliveryPoliceOpen] = useState(false);
  const [returnPolicyOpen, setReturnPolicyOpen] = useState(false);
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
  const [termsConditionsOpen, setTermsConditinosOpen] = useState(false);
  const [payImages, setPayImages] = useState([]);
  const [socials, setSocials] = useState([]);
  const [downloads, setDownLoads] = useState([]);
  const [siteInfo, setSiteInfo] = useState({});
  const handleOpenPopUp = (name) => {
    if (name === "contact") {
      setContactOpen(true);
    } else if (name === "branches") {
      setBranchesOpen(true);
    } else if (name === "returnPolicy") {
      setReturnPolicyOpen(true);
    } else if (name === "deliveryPolicy") {
      setDeliveryPoliceOpen(true);
    } else if (name === "termsConditions") {
      setTermsConditinosOpen(true);
    } else if (name === "privacyPolicy") {
      setPrivacyPolicyOpen(true);
    }
  };
  const getSiteInfo = () => {
    Axios({
      url: BASE_URL + `site_info/get_all_for_user`,
      method: "GET",
    })
      .then((res) => {
        ;
        if (res?.status == "success") {
          setSiteInfo(res?.result);
          setPayImages(res?.result?.payimgs);
          setDownLoads(res?.result?.downloads);
          setSocials(res?.result?.socails);
        }
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (data?.payimgs) {
      setSiteInfo(data);
      setPayImages(data?.payimgs);
      setDownLoads(data?.downloads);
      setSocials(data?.socails);
    }
    // getSiteInfo();
  }, [data]);
  return (
    <footer>
      <div className="footer">
        <div className="topFooter">
          <div className="rowDiv">
            {footerData?.map((item, index) => {
              return (
                <div className="footerComponent">
                  <h3>{item?.title[language]}</h3>
                  <ul>
                    {item?.items?.map((item) => {
                      return (
                        <li>
                          {item.link !== "#" ? (
                            <Link to={item?.link}>{item?.label[language]}</Link>
                          ) : (
                            <Link onClick={() => handleOpenPopUp(item.name)}>
                              {item?.label[language]}
                            </Link>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                  <div
                    // style={{ justifyContent: "center" }}
                    className="footerComponentFooter"
                  >
                    {index == 0
                      ? payImages?.map((item) => {
                          return (
                            <img
                              style={{
                                cursor: 'pointer',
                                objectFit: "contain",
                              }}
                              width={30}
                              height={30}
                              onClick={() => {
                                window.open(item?.link, "_blank");
                              }}
                              alt=""
                              src={item?.image}
                            />
                          );
                        })
                      : index == 1
                      ? downloads?.map((item) => {
                          return (
                            <img
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                window.open(item.link, "_blank");
                              }}
                              alt=""
                              src={item.image}
                            />
                          );
                        })
                      : socials?.map((item) => {
                          return (
                            <img
                            className="socialsIcons"
                              style={{ width: "30px", borderRadius: "50%" }}
                              alt=""
                              src={item.icon}
                              role="button"
                              onClick={() =>
                                window.open(item?.account, "_blanck")
                              }
                            />
                          );
                        })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <CopyRight
          copyRight={
            language == "ar" ? siteInfo.copy_right_ar : siteInfo.copy_right_en
          }
        />
      </div>
    </footer>
  );
};

export default Footer;
